module.exports = __webpack_public_path__ + "img/box-usz.16b37aa8.svg";